/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Female11Inputs */

const en__field_enum_icsrm_female11 = /** @type {(inputs: _Field_Enum_Icsrm_Female11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`female`)
};

const de__field_enum_icsrm_female11 = /** @type {(inputs: _Field_Enum_Icsrm_Female11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`weiblich`)
};

/**
* | output |
* | --- |
* | "female" |
*
* @param {_Field_Enum_Icsrm_Female11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_female11 = /** @type {((inputs?: _Field_Enum_Icsrm_Female11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Female11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_female11(inputs)
	return de__field_enum_icsrm_female11(inputs)
});
export { _field_enum_icsrm_female11 as "_field_enum_ICSRM_FEMALE" }